import { render, staticRenderFns } from "./workspace-duplicate-option-modal.vue?vue&type=template&id=5cbfe0e7&"
import script from "./workspace-duplicate-option-modal.vue?vue&type=script&lang=js&"
export * from "./workspace-duplicate-option-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports